import React from 'react';

export default function Blog() {
  return (
    <main className="page">
      <section className="hero">
        <p className="hero__eyebrow">From the desk</p>
        <h1 className="hero__title">Blog</h1>
        <p className="hero__subtitle">
          Notes, updates, and behind-the-scenes dispatches from the OnlyFreeNews team.
        </p>
      </section>
    </main>
  );
}
